import React, { useState, useEffect } from "react"
import calculateProbableFlow from "./calculateProbableFlow"
import { useFlow } from "./contexts/FlowContext"
import { Card, Row, Col, Button, InputNumber, Divider } from "antd"

import "./FlowCalculator.css"

const appliances = [
    { name: "Tvättmaskin", rate: 12, imageName: "tvattmaskin" },
    { name: "Diskmaskin", rate: 12, imageName: "diskmaskin" },
    { name: "Tvättställsblandare", rate: 6, imageName: "tvattstallsblandare" },
    { name: "Köksblandare", rate: 12, imageName: "koksblandare" },
    { name: "Badkarsblandare", rate: 18, imageName: "badkarsblandare" },
    { name: "Duschblandare", rate: 12, imageName: "duschblandare" },
    { name: "WC", rate: 6, imageName: "wc" },
    { name: "Vattenutkastare", rate: 12, imageName: "vattenutkastare" }
]

const Appliance = ({ name, rate, onUpdate, imageName }) => {
    const [count, setCount] = useState(0)

    const handleCountChange = (newCount) => {
        if (newCount >= 0) {
            const flowDelta = (newCount - count) * rate
            setCount(newCount)
            onUpdate(name, flowDelta)
        }
    }

    const ratePrefix = rate === 6 ? "\u00A0" : ""

    return (
        <Card className="flow-calculator-card">
            <div className="appliance-container">
                <div className="appliance-image">
                    <img src={`${process.env.PUBLIC_URL}/images/${imageName}.png`} alt={name} />
                </div>
                <div className="appliance-name">{name}</div>
                <div className="appliance-control">
                    <Button className="control-button" onClick={() => handleCountChange(count - 1)} disabled={count <= 0}>
                        -
                    </Button>
                    <InputNumber className="control-input" min={0} value={count} onChange={handleCountChange} />
                    <Button className="control-button" onClick={() => handleCountChange(count + 1)}>
                        +
                    </Button>
                    <span>{`${ratePrefix}st x ${rate} l/min`}</span>
                    <InputNumber className="appliance-flow" value={count * rate} readOnly />
                </div>
            </div>
        </Card>
    )
}

const FlowCalculator = () => {
    const [flows, setFlows] = useState({})
    const { setProbableFlow } = useFlow()

    const handleApplianceUpdate = (applianceName, flowDelta) => {
        setFlows((prevFlows) => ({
            ...prevFlows,
            [applianceName]: (prevFlows[applianceName] || 0) + flowDelta
        }))
    }

    useEffect(() => {
        const totalFlow = Object.values(flows).reduce((acc, flow) => acc + flow, 0)
        setProbableFlow(calculateProbableFlow(totalFlow))
    }, [flows, setProbableFlow])

    return (
        <Row gutter={[2, 2]}>
            {appliances.map((appliance) => (
                <Col span={24} key={appliance.name}>
                    <Appliance
                        name={appliance.name}
                        rate={appliance.rate}
                        imageName={appliance.imageName}
                        onUpdate={handleApplianceUpdate}
                    />
                </Col>
            ))}
            <Col span={24}>
                <Card size="medium" style={{ textAlign: "center", backgroundColor: "#d0e9f5" }}>
                    <p style={{ fontWeight: "bold" }}>Normflöde: {Object.values(flows).reduce((acc, flow) => acc + flow, 0)} liter/minut</p>
                    <p style={{ fontWeight: "bold" }}>
                        Sannolikt flöde: {calculateProbableFlow(Object.values(flows).reduce((acc, flow) => acc + flow, 0))} liter/minut
                    </p>
                </Card>
            </Col>
        </Row>
    )
}

export default FlowCalculator
